const AppStyle = {
    yellow: '#E5F15E',
    white: '#FFFFFF',
    dark  : '#303030',
    dark_hover  : '#2d2d2d'
};

export default AppStyle;